module.exports = __webpack_public_path__ + "img/california.f5243793.png";